import type { Line } from '../types';

// packages/lyric-stage/src/lyrics/findActiveLine.ts

/**
 * Latest line whose startTime <= now.
 * If that line has already passed endTime and the next line has not started yet,
 * return -1 so intro credits / gaps clear instead of holding the last line forever.
 */
export const findLatestActiveLineIndex = (
  lines: readonly Pick<Line, 'startTime' | 'endTime'>[],
  currentTimeSec: number,
): number => {
  if (lines.length === 0 || currentTimeSec < 0) {
    return -1;
  }

  let low = 0;
  let high = lines.length - 1;
  let result = -1;

  while (low <= high) {
    const mid = (low + high) >> 1;
    const start = lines[mid]!.startTime;
    if (start <= currentTimeSec) {
      result = mid;
      low = mid + 1;
    } else {
      high = mid - 1;
    }
  }

  if (result < 0) return -1;

  const active = lines[result]!;
  const end = Number(active.endTime);
  if (Number.isFinite(end) && currentTimeSec >= end) {
    const next = lines[result + 1];
    if (!next || next.startTime > currentTimeSec) {
      return -1;
    }
  }

  return result;
};
